import { assignColorsToCssVariables } from '@/helpers/colors'

const colorsFromAppState = window.__appState?.style?.colors;
if (colorsFromAppState) {
  assignColorsToCssVariables(colorsFromAppState);
} else {
  import('@/bootstrap/defaults/default-colors').then(module => assignColorsToCssVariables(module.default));
}
